import React, { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataType3Preguntas } from '../../../interfaces/utils'
import { AllCardsType } from '../../../data/all-cards'
import { Zodiaco, ZodiacoType } from '../../../data/zodiaco'
import {copyResponse,
    fotoCartas,
    getMazo,
    getMazoName,
    getTapiz,
    getZodiac,
    isEmpty,
    selectCards,
    setMezcla, formatSignAndAge} from '../../../utils/functions'
import { GetConsult, SaveAllCards } from '../../../store/actions'
import { ButtonNormal } from '../../../components/buttons/button-normal'
import { ButtonReinterpret } from '../../../components/buttons/button-reinterpret'
import PhotoCards from './photo-cards'
import { ShowCards } from './show-cards'
import { useNavigate } from 'react-router-dom'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import { interpret } from './functions'
import MarqueeText from '../../../components/MarqueeText'
import { NombreTarotista} from '../../../data/personality'
import PersonalitySelector from '../../../components/personality-selector'

const TresPreguntas = () => {
    const dispatch: Dispatch<any> = useDispatch()
    const navigate = useNavigate()
    const [data, setData] = useState<DataType3Preguntas>({
        consultante: {
            name: '',
            date: '',
            zodiac: '',
            phone: '',
        },
        consulta1: '',
        consulta2: '',
        consulta3: '',
    })
    const [copia, setCopia]: any = useState(false)
    const { allCards, user, consult, loading } = useSelector((state: any) => state)
    const [response, setResponse] = useState('')
    const [selectedCards, setSelectedCards] = useState<AllCardsType[]>([])
    const [showResponse, setShowResponse] = useState<boolean>(false)
    const [status, setStatus] = useState({
        isDone: false,
        mezcladas: false,
        repartidas: false,
        isConsulting: false,
        isInterpret: false,
    })
    const zodiaco: ZodiacoType[] = Zodiaco
    const [personalidad, setPersonalidad] = useState<NombreTarotista>()

    // SETEA LOS ESTADOS PARA REALIZAR UNA NUEVA CONSULTA CON EL MISMO CLIENTE
    const nuevaPregunta = () => {
        setResponse('')
        setStatus({
            ...status,
            isDone: false,
            mezcladas: false,
            repartidas: false,
            isInterpret: false,
        })
        setData({
            ...data,
            consulta1: '',
            consulta2: '',
        })
        setShowResponse(false)
        setSelectedCards([])
    }

    // LIMPIA LOS ESTADOS PARA ATENDER UN NUEVO CLIENTE
    const nuevoCliente = () => {
        setResponse('')
        setStatus({
            ...status,
            isDone: false,
            mezcladas: false,
            repartidas: false,
            isInterpret: false,
        })
        setData({
            consultante: {
                name: '',
                date: '',
                zodiac: '',
            phone: '',
            },
            consulta1: '',
            consulta2: '',
            consulta3: '',
        })
        setShowResponse(false)
        setSelectedCards([])
    }

    // MANEJA LOS ESTADOS
    const handleStatus = (name: string, value: boolean): void => {
        setStatus({
            ...status,
            [name]: value,
        })
    }

    // RECIBE UNA FECHA Y DEVUELVE EL SIGNO ZODIACAL
    const handleZodiacConsultant = (date: string): void => {
        let zodiac = getZodiac(date)
        setData({
            ...data,
            consultante: {
                ...data.consultante,
                zodiac,
                date,
            },
        })
    }

    // MANEJA LOS INPUTS DE LOS DATOS DEL CONSULTANTE
    const handleInputConsultant = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.name === 'date' && parseInt(event.target.value.slice(0, 4)) > 1900) {
            handleZodiacConsultant(event.target.value)
        } else {
            setData({
                ...data,
                consultante: {
                    ...data.consultante,
                    [event.target.name]: event.target.value,
                },
            })
        }
    }

    // MANEJA EL TEXTAREA DE LA CONSULTA
    const handleConsult = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        })
    }

    // MEZCLA LAS CARTAS
    const mezcla = () => {
        const mezcladas = setMezcla(allCards)
        dispatch(SaveAllCards(mezcladas))
        handleStatus('mezcladas', true)
    }

    // PREPARA LA INFORMACION Y DISPARA LA CONSULTA A LA IA
    const interpretar = () => {
        handleStatus('isConsulting', true)
        const info = interpret(selectedCards, data, user.username, personalidad!, '3-preguntas')
        dispatch(GetConsult(info))
    }

    useEffect(() => {
        if (status.mezcladas && !status.repartidas) {
            setSelectedCards(selectCards(allCards, 15))
            setStatus((s) => ({ ...s, repartidas: true }))
        }
    }, [allCards, status.mezcladas, status.repartidas])

    useEffect(() => {
        if (!isEmpty(consult) && !loading) {
            setStatus((s) => ({
                ...s,
                isConsulting: false,
                isInterpret: true,
            }))
            setResponse(consult.response)
            setShowResponse(true)
        } else if (!isEmpty(consult) && loading) {
            setResponse(consult.response)
            setShowResponse(true)
        }
    }, [consult, loading])

    useEffect(() => {
        const saved = localStorage.getItem('personality')
        if (Object.entries(user).length === 0 || isEmpty(saved)) {
            navigate('/')
        } else {
            setPersonalidad(saved as NombreTarotista)
        }
        setStatus({
            isConsulting: false,
            isInterpret: false,
            isDone: false,
            repartidas: false,
            mezcladas: false,
        })
        setShowResponse(false)
        setResponse('')
        setSelectedCards([])
    // eslint-disable-next-line react-hooks/exhaustive-deps -- inicialización solo al montar
    }, [])

    useEffect(() => {
        if (Object.entries(user).length === 0) {
            navigate('/')
        }
    }, [user, navigate])

    // MUESTRA UNA DERSCRIPCION DEL SIGNO DEL ZODIACO DEL CONSULTANTE
    useEffect(() => {
        if (showResponse) {
            let signoConsultante = document.getElementById('consultante')
            if (signoConsultante && data.consultante.zodiac.length > 0) {
                let description = zodiaco.filter((signo) => signo.name === data.consultante.zodiac)
                signoConsultante.innerHTML = description[0].description
            }
        }
    }, [showResponse, data, zodiaco])

    // COPIA LA IMAGEN DE LAS CARTAS
    useEffect(() => {
        if (copia) {
            let element = document.getElementById('photo')
            if (element) {
                fotoCartas(element, data.consultante.name)
                setCopia(false)
            }
        }
    }, [copia, data.consultante.name])

    const copiar = () => {
        localStorage.setItem('client', JSON.stringify(data.consultante))
    }

    const pegar = () => {
        const cliente = localStorage.getItem('client')
        if (cliente) {
            const clienteObj = JSON.parse(cliente)
            console.log(clienteObj)
            setData({
                ...data,
                consultante: {
                    name: clienteObj.name,
                    date: clienteObj.date,
                    zodiac: clienteObj.zodiac,
                    phone: clienteObj.phone || '',
                },
            })
        }
    }

    // MANEJA LA SELECCION DE PERSONALIDADES
    const handlePersonalitySelector = (id: NombreTarotista) => {
        localStorage.setItem('personality', id)
        setPersonalidad(id)
    }

    return (
        <div className="relative w-full bg-no-repeat bg-cover mini:min-h-screen mini:h-full xl:h-height-main bg-pregunta mini:px-2 md:px-4">
            <p className="w-full py-5 italic font-bold text-center text-white mini:text-xl xl:text-4xl drop-shadow-lg">
                Tirada para 3 Preguntas
            </p>
            <div className="flex w-full mini:flex-col xl:flex-row">
                {/* left */}
                <div className="flex flex-col h-full gap-6 rounded-lg mini:w-full xl:w-1/2 bg-violetLight/70 mini:px-2 mini:py-5 md:p-5 shadow-card-horizontal">
                    <div className="flex flex-col gap-3">
                        <div className="flex gap-3 mini:flex-col md:flex-row">
                            <input
                            name="name"
                            type="text"
                            value={data.consultante.name}
                            onChange={(e) => handleInputConsultant(e)}
                            placeholder="Nombre del Consultante"
                            className="h-10 pl-3 text-base text-gray-400 rounded-lg mini:w-full md:w-1/2 focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                            autoFocus={true}
                        />
                        <div className="flex gap-3">
                            <input
                                type="date"
                                name="date"
                                value={data.consultante.date}
                                onChange={(e) => handleInputConsultant(e)}
                                placeholder="Nacimiento"
                                className="w-1/2 pl-3 text-base text-gray-400 rounded-lg pr-1lh-10 focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                            />
                            <input
                                type="text"
                                name="zodiac"
                                value={formatSignAndAge(data.consultante.zodiac, data.consultante.date)}
                                readOnly={true}
                                className="w-1/2 h-10 px-3 text-base text-gray-400 rounded-lg disabled:bg-white"
                                disabled={true}
                            />
                        </div>
                        <div className="flex items-center gap-1 text-white">
                            <button
                                className="p-2 rounded-full bg-violetDark hover:cursor-pointer disabled:bg-slate-400 disabled:text-slate-300 disabled:cursor-not-allowed"
                                onClick={() => copiar()}
                                title="Copiar"
                                disabled={data.consultante.name.length === 0 || data.consultante.zodiac.length === 0}
                            >
                                <ContentCopyIcon />
                            </button>
                            <button
                                className="p-2 rounded-full bg-violetDark hover:cursor-pointer"
                                onClick={() => pegar()}
                                title="Pegar"
                            >
                                                                                        <ContentPasteIcon />
                            </button>
                        </div>

                    </div>
                    </div>
                    <div>
                        <textarea
                            name="consulta1"
                            value={data.consulta1}
                            className="p-3 h-[15vh] rounded-lg textr-base text-gray-400 w-full resize-none"
                            placeholder="Primer consulta"
                            onChange={(e) => handleConsult(e)}
                        />
                    </div>
                    <div>
                        <textarea
                            name="consulta2"
                            value={data.consulta2}
                            className="p-3 h-[15vh] rounded-lg textr-base text-gray-400 w-full resize-none"
                            placeholder="Segunda consulta"
                            onChange={(e) => handleConsult(e)}
                        />
                    </div>
                    <div>
                        <textarea
                            name="consulta3"
                            value={data.consulta3}
                            className="p-3 h-[15vh] rounded-lg textr-base text-gray-400 w-full resize-none"
                            placeholder="Tercera consulta"
                            onChange={(e) => handleConsult(e)}
                        />
                    </div>
                    <div className="flex flex-wrap justify-center gap-3 disabled:hidden">
                        <ButtonNormal
                            caption="Hecho"
                            onClick={() => handleStatus('isDone', true)}
                            disabled={
                                status.isDone ||
                                data.consultante.name.length === 0 ||
                                data.consultante.date.length === 0 ||
                                data.consulta1.length === 0 ||
                                data.consulta2.length === 0 ||
                                data.consulta3.length === 0
                            }
                        />
                        <ButtonNormal
                            caption="Repartir"
                            onClick={() => mezcla()}
                            disabled={!status.isDone || status.repartidas}
                        />
                        <ButtonNormal
                            caption="Editar"
                            onClick={() => handleStatus('isDone', false)}
                            disabled={!status.isDone || status.repartidas}
                        />
                        <ButtonNormal
                            caption="Hacer foto de cartas"
                            onClick={() => setCopia(true)}
                            disabled={!status.repartidas || status.isConsulting}
                        />
                        <ButtonNormal
                            caption={status.isConsulting ? 'Interpretando' : 'Interpretar'}
                            onClick={() => interpretar()}
                            disabled={!status.repartidas || status.isInterpret}
                            loading={loading}
                        />
                        <ButtonReinterpret
                            isConsulting={status.isConsulting}
                            onConfirm={() => interpretar()}
                            disabled={!status.isInterpret}
                            loading={loading}
                        />
                        <ButtonNormal
                            caption="Ver Respuesta"
                            onClick={() => setShowResponse(true)}
                            disabled={response?.length === 0}
                        />
                        <ButtonNormal
                            caption="Nueva Tirada"
                            onClick={() => nuevaPregunta()}
                            disabled={!status.isInterpret}
                        />
                        <ButtonNormal
                            caption="Nuevo Cliente"
                            onClick={() => nuevoCliente()}
                            disabled={!status.isInterpret}
                        />
                    </div>
                    <div className="w-full font-semibold text-red-400 bg-black h-[24px]">
                        <MarqueeText text={'Estás usando el mazo de cartas: ' + getMazoName(user.tarot)} speed={15} />
                    </div>
                </div>
                {/* right */}
                {selectedCards.length > 0 ? (
                    <div className="relative mini:w-full xl:w-1/2 mini:py-10 xl:py-0">
                        <ShowCards selectedCards={selectedCards} mazo={getMazo(user.tarot)} />
                    </div>
                ) : null}
                {selectedCards.length > 0 ? (
                    <div
                        className={`absolute top-0 left-0 w-screen h-screen flex justify-center items-center ${
                            copia ? 'block' : 'hidden'
                        }`}
                    >
                        <div className="w-fit h-fit" id="photo">
                            <PhotoCards cards={selectedCards} mazo={getMazo(user.tarot)} tapiz={getTapiz(user.tarot)} />
                        </div>
                    </div>
                ) : null}
                {showResponse ? (
                    <div className="absolute w-[90vw] h-[90vh] top-[2%] left-[5%] bg-zinc-200 shadow-2xl flex flex-row gap-5 rounded-xl mini:p-2 md:p-5">
                        <div className="flex flex-col gap-3 mini:w-full xl:w-2/3">
                            <textarea
                                className="w-full h-full p-5 rounded-lg resize-none"
                                value={response}
                                onChange={(e) => setResponse(e.target.value)}
                            />
                            <div className="flex flex-row flex-wrap justify-center gap-1">
                                <ButtonNormal
                                    caption="Volver"
                                    onClick={() => setShowResponse(false)}
                                    disabled={loading}
                                />
                                <ButtonNormal
                                    caption="Copiar Respuesta"
                                    onClick={() => copyResponse(response)}
                                    disabled={loading}
                                />
                                <ButtonNormal
                                    caption="Nueva Pregunta"
                                    onClick={() => nuevaPregunta()}
                                    disabled={loading}
                                />
                                <ButtonNormal
                                    caption="Nuevo Cliente"
                                    onClick={() => nuevoCliente()}
                                    disabled={loading}
                                />
                                <ButtonNormal
                                    caption="Generando"
                                    loading={loading}
                                    disabled={!loading}
                                    onClick={() => {}}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-1/3 gap-3 mini:hidden xl:block">
                            <p className="font-semibold">Consultante: {data.consultante.zodiac}</p>
                            <div
                                className="w-full p-5 overflow-y-auto text-sm rounded-lg bg-zinc-50"
                                id="consultante"
                            ></div>
                        </div>
                    </div>
                ) : null}
            </div>
            <PersonalitySelector selected={personalidad} onChange={handlePersonalitySelector} />
        </div>
    )
}

export default TresPreguntas
